import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../utils/api';
import { GOAL_LABELS } from '../supplements/RecommendationsCard';

// One row: the top supplement ideas for your goal, as chips, linking to the
// Supplements page where the evidence and the "add to stack" button live.

const SupplementIdeasRow = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    apiClient.get('/api/recommendations')
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);
  const recs = data?.recommendations || [];
  if (!recs.length) return null;
  const goal = (data.goals || [])[0];
  const names = [...new Set(recs.map((r) => r.name))].slice(0, 3);

  return (
    <section className="mt-10">
      <h2 className="mb-3.5 text-[1.2rem] font-medium tracking-[-0.015em]">Supplements</h2>
      <Link to="/supplements"
        className="flex flex-wrap items-center justify-between gap-4 rounded-xl border border-line px-5 py-4 text-fg transition-colors hover:bg-raised">
        <div>
          <div className="text-[1.1rem] font-medium">Ideas{goal ? ` for ${(GOAL_LABELS[goal] || goal).toLowerCase()}` : ''}</div>
          <div className="mt-0.5 text-sm text-fg-3">Based on your goals. Evidence on every one.</div>
        </div>
        <div className="flex flex-wrap gap-2">
          {names.map((n) => (
            <span key={n} className="rounded-full border border-line-strong px-3 py-1.5 text-sm text-fg-2">{n}</span>
          ))}
          <span className="rounded-full border border-line-strong px-3 py-1.5 text-sm text-fg-2">See all →</span>
        </div>
      </Link>
    </section>
  );
};

export default SupplementIdeasRow;
